import type {Product} from './product'

export type ParcelSize = 'small' | 'medium' | 'large' | 'custom'

export const enum ParcelPaymentType {
  Payed = 'payed',
  OnDemand = 'onDemand',
}

export type ParcelDimensions = {
  height: number
  length: number
  weight: number
  width: number
}

export type CustomParcelSizes = Record<Exclude<ParcelSize, 'custom'>, ParcelDimensions>

export type Parcel = {
  // Название посылки
  name: string
  // Штрих-код
  barcode: string
  // Размер посылки (small, medium, large, custom)
  size: ParcelSize
  // Тип оплаты
  payment: ParcelPaymentType
  // Размеры посылки
  dimensions?: ParcelDimensions
  // Список товаров в посылке
  products: Array<Product>
}
